// extracted by mini-css-extract-plugin
export default {"marqueeContainer":"Marquee_marqueeContainer__qdCBD","marqueeContent":"Marquee_marqueeContent__PC7C+","scroll":"Marquee_scroll__ilK1y","message":"Marquee_message__84NAv"};